import { useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProductionDeclarationGuidelineContent } from '@/features/production-declaration/components/guideline/production-declaration-guideline-content';

export function ProductionDeclarationGuidelinePage() {
  const { id } = useParams({ strict: false });
  const { t } = useTranslation('productionDeclaration');

  return (
    <div className='space-y-10'>
      <h1 className='font-semibold text-4xl text-declaration-foreground tracking-tight'>
        {t('guideline.title')}
      </h1>
      <ProductionDeclarationGuidelineContent
        productionDeclarationId={`${id}`}
      />
    </div>
  );
}
